{
  "shellWaitLabel": "Caricamento in corso"
}
